// import logo = lazy(() => import(".logo.svg";
import "./App.css";
import { useEffect, useState, Suspense, lazy } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Cookie from "js-cookie";
import commonData from "./importanValue";
import OneSignal from "react-onesignal";
import ProtectedRoute from "./components/ProtectedRoute";
import sendPushAdmin from "./components/admin/Sendpush";
import Loader from "./components/Loader";
import Notifications from "./components/main/Notifications";
import SubjectSelection from "./components/subjects";
import PromoteMessageComponent from "./components/admin/Promote";
import TodayExams from "./components/main/TodayExams";
import BookOrder from "./components/admin/BookOrders";
import MessageSMSComponent from "./components/admin/Promote-sms";
import UserQuestions from "./components/main/UserQuestions";
import UserExams from "./components/main/UserExams";
// import ReferAdmin from "./components/admin/ReferAdmin";
import { WebsiteProvider } from "./context/WebsiteContext";

const HomePage = lazy(() => import("./components/HomePage"));
const NotFound = lazy(() => import("./components/NotFound"));
const Register = lazy(() => import("./components/Register"));
const LoginHome = lazy(() => import("./components/LoginHome"));
const DailyCA = lazy(() => import("./components/main/DailyCA"));
const EditUserProfile = lazy(() => import("./components/main/EditUserProfile"));
const ExamSchedules = lazy(() => import("./components/main/ExamSchedules"));
const ExamsList = lazy(() => import("./components/main/ExamsList"));
const FreeContentPreview = lazy(() => import("./components/main/FreeContentPreview"));
const BucketExamsList = lazy(() => import("./components/main/BucketExamsList"));
const ResultsList = lazy(() => import("./components/main/ResultsList"));
const Syllabus = lazy(() => import("./components/main/Syllabus"));
const ExamDetails = lazy(() => import("./components/main/ExamDetails"));
const ExamDetailsPaid = lazy(() => import("./components/main/ExamDetailsPaid"));
const ExamLink = lazy(() => import("./components/main/ExamLink"));

const AttemptQuiz = lazy(() => import("./components/main/AttemptQuiz"));
const ViewResult = lazy(() => import("./components/main/ViewResult"));
const Payumoney = lazy(() => import("./components/main/Payumoney"));
const PaymentFailed = lazy(() => import("./components/PaymentFailed"));
const Dashboard = lazy(() => import("./components/admin/Dashboard"));
const UserList = lazy(() => import("./components/admin/UserList"));
const ReferAdmin = lazy(() => import("./components/admin/ReferAdmin"));
const PercentageMessagesAdmin = lazy(() => import("./components/admin/PercentageMessagesAdmin"));

const ReportedQuestions = lazy(() =>
  import("./components/admin/ReportedQuestions")
);
const Questions = lazy(() => import("./components/admin/Questions"));
const AddNewPackage = lazy(() => import("./components/admin/AddNewPackage"));
const AdminResultsList = lazy(() =>
  import("./components/admin/AdminResultList")
);
const CategoryList = lazy(() => import("./components/admin/CategoryList"));
const Coupons = lazy(() => import("./components/admin/Coupons"));
const AdminExamsList = lazy(() => import("./components/admin/ExamsList"));
const AddNewExam = lazy(() => import("./components/admin/AddNewExam"));
const Links = lazy(() => import("./components/admin/Links"));
const LiveExamPresentation = lazy(() => import("./components/admin/LiveExamPresentation"));
const HierarchyManager = lazy(() => import("./components/admin/HierarchyManager"));
// import Notifier from "./components/Notifier";

const ExportPaymentList = lazy(() =>
  import("./components/admin/ExportPaymentList")
);
const PaymentDetails = lazy(() =>
  import("./components/admin/PaymentDetails")
);
const AutoResponder = lazy(() => import("./components/admin/AutoResponder"));
const Support = lazy(() => import("./components/main/Support"));
const userWallet = lazy(() => import("./components/main/UserWallet"));
const ReportedQuestionsByMe = lazy(() => import("./components/main/ReportedQuestionsByMe"));
 
// import PushNotifications from "./components/admin/PushNotification";
function App() {
  // const token = Cookie.get("jwt_token");
  // const uid = localStorage.getItem("uid");

  const token = Cookie.get("jwt_token");

  useEffect(async () => {
    await OneSignal.init({ appId: commonData["app_id"] });
  });

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="loader-main-container">
            <Loader />
          </div>
        }
      >
        <Route path="/:websiteId">
          <WebsiteProvider>
            <Switch>
            <ProtectedRoute
                path="/:websiteId/moderator/question-bank"
                exact
                component={UserQuestions}
              />
              <ProtectedRoute
                path="/:websiteId/notifications"
                exact
                component={Notifications}
              />
              <ProtectedRoute
                path="/:websiteId/user/reported-questions"
                exact
                component={ReportedQuestionsByMe}
              />
              <ProtectedRoute
                path="/:websiteId/send-sms-messages"
                exact
                component={MessageSMSComponent}
              />
              <ProtectedRoute path="/:websiteId/book-orders" exact component={BookOrder} />
              <Route path="/:websiteId/select-the-exams" exact component={SubjectSelection} />
              <Route
                path="/:websiteId/payumoney/payment/checkout/:gid/:bucketId"
                exact
                component={Payumoney}
              />
               <ProtectedRoute
                path="/:websiteId/package/:gid/:bucketId"
                exact
                component={Payumoney}
              />
              <Route path="/:websiteId/payment-failed" exact component={PaymentFailed} />
              {/* <ProtectedRoute path="" exact component={HomePage} /> */}
              <ProtectedRoute
                path={[
                  "/:websiteId",
                  "/:websiteId/index.php/login",
                  "/:websiteId/index.html",
                  "/:websiteId/login/registration/",
                ]}
                exact
                component={HomePage}
              />
              <ProtectedRoute
                path="/:websiteId/exams-list/:guid/:bucketId"
                exact
                component={ExamsList}
              />
              <Route
                path="/:websiteId/free-content-preview/:gid"
                exact
                component={FreeContentPreview}
              />
              <ProtectedRoute
                path="/:websiteId/send-messages"
                exact
                component={PromoteMessageComponent}
              />
              <ProtectedRoute
                path="/:websiteId/exams-list/:guid/:bucketId/aG9tZQ=="
                exact
                component={BucketExamsList}
              />
              <ProtectedRoute
                path="/:websiteId/exam-details/:quid"
                exact
                component={ExamDetails}
              />
              <ProtectedRoute
                path="/:websiteId/exam-link/:quid"
                exact
                component={ExamLink}
              />
              <ProtectedRoute
                path="/:websiteId/attempt-exam/:quid"
                exact
                component={AttemptQuiz}
              />
              <ProtectedRoute
                path="/:websiteId/view-result/:uid/:quizid/:resultid"
                exact
                component={ViewResult}
              />
              <ProtectedRoute
                path={["/:websiteId/results-list", "/:websiteId/index.php/result/"]}
                exact
                component={ResultsList}
              />
              <ProtectedRoute
                path="/:websiteId/user-profile"
                exact
                component={EditUserProfile}
              />
              {/* {uid === undefined ? (
              <Route path="/:websiteId/login" exact component={LoginHome} />
            ) : (
              token !== undefined && <Redirect to="/:websiteId/" />
            )} */}
              <Route path="/:websiteId/login" exact component={LoginHome} />
              <ProtectedRoute path="/:websiteId/todays-exams" exact component={TodayExams} />
              <ProtectedRoute
                path={["/:websiteId/exams-schedules", "/:websiteId/app/schedule.html"]}
                exact
                component={ExamSchedules}
              />
              <ProtectedRoute
                path={["/:websiteId/syllabus-in-telugu", "/:websiteId/app/syllabus.html"]}
                exact
                component={Syllabus}
              />
              <ProtectedRoute
                path={[
                  "/:websiteId/study-materials",
                  "/:websiteId/app/dailyca.html",
                  "/:websiteId/app/materials.html",
                ]}
                exact
                component={DailyCA}
              />
              {/* {uid === undefined ? (
              <Route path="/:websiteId/register-new-account" exact component={Register} />
            ) : (
              <Redirect to="/:websiteId/login" />
            )} */}
              <ProtectedRoute path="/:websiteId/admin/users" exact component={UserList} />
              <ProtectedRoute path="/:websiteId/admin/dashboard" exact component={Dashboard} />
              <ProtectedRoute
                path="/:websiteId/admin/qbank/view-all"
                exact
                component={Questions}
              />
              <ProtectedRoute
                path="/:websiteId/admin/qbank/reported-questions/:quizid/:id"
                exact
                component={ReportedQuestions}
              />
              <ProtectedRoute
                path="/:websiteId/admin/qbank/categories"
                exact
                component={CategoryList}
              />
              <ProtectedRoute
                path="/:websiteId/admin/hierarchy-manager"
                exact
                component={HierarchyManager}
              />
              <ProtectedRoute
                path="/:websiteId/admin/group/add-new-package"
                exact
                component={AddNewPackage}
              />
              <ProtectedRoute
                path="/:websiteId/admin/result/view-all"
                exact
                component={AdminResultsList}
              />
              <ProtectedRoute
                path="/:websiteId/admin/others/coupons"
                exact
                component={Coupons}
              />
              <ProtectedRoute
                path="/:websiteId/admin/exams/view-all"
                exact
                component={AdminExamsList}
              />
              <ProtectedRoute
                path="/:websiteId/admin/exams/add-edit-exam/:examid"
                exact
                component={AddNewExam}
              />
              <ProtectedRoute
                path="/:websiteId/admin/live-exam-presentation/:quid"
                exact
                component={LiveExamPresentation}
              />
              <ProtectedRoute
                path="/:websiteId/admin/others/all-links/:category"
                exact
                component={Links}
              />
              <ProtectedRoute
                path="/:websiteId/admin/others/send-push"
                exact
                component={sendPushAdmin}
              />
              <ProtectedRoute
                path="/:websiteId/admin/others/auto-responder"
                exact
                component={AutoResponder}
              />
              <ProtectedRoute
                path="/:websiteId/admin/others/percentage-messages"
                exact
                component={PercentageMessagesAdmin}
              />
              <ProtectedRoute
                path="/:websiteId/admin/user/referdata"
                exact
                component={ReferAdmin}
              />
              <Route path="/:websiteId/register-new-account" exact component={Register} />
              <Route
                path="/:websiteId/export-payment-data/:date"
                exact
                component={ExportPaymentList}
              />
              <ProtectedRoute
                path="/:websiteId/admin/payment-details"
                exact
                component={PaymentDetails}
              />
              <Route path="/:websiteId/not-found" exact component={NotFound} />
              <ProtectedRoute path="/:websiteId/support/user/:id" exact component={Support} />
              <ProtectedRoute
                path="/:websiteId/user/user-wallet"
                exact
                component={userWallet}
              />
              <ProtectedRoute path="/:websiteId/support" exact component={Support} />
              <ProtectedRoute
                path="/:websiteId/moderator/exam-bank"
                exact
                component={UserExams}
              />
              <Route render={({ match }) => <Redirect to={`/${match.params.websiteId}/not-found`} />} />
            </Switch>
          </WebsiteProvider>
        </Route>
        {/* <Support /> */}
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
